/**
 * グループ情報を操作するクラス
 */
class ValueConverer {
  /**
   * グループ一覧をセレクトボックス向けのデータに変換する
   * @param {グループ一覧} group_list
   * @returns
   */
  groupForSelectbox(group_list, owner_group_ids) {
    const selectboxList = group_list.map((group) => {
      return {
        text: group.display_name,
        value: group.group_id,
      };
    });
    selectboxList.sort((a, b) => {
      if (owner_group_ids) {
        let aPriority = 0;
        let bPriority = 0;
        if (owner_group_ids.includes(a.value)) {
          aPriority = 1;
        }
        if (owner_group_ids.includes(b.value)) {
          bPriority = 1;
        }
        if (aPriority != bPriority) {
          return bPriority - aPriority;
        }
      }
      return a.text.localeCompare(b.text);
    });
    return selectboxList;
  }

  dataTableDefaultSort(items, sortBy, sortDesc) {
    const sortKey = sortBy[0];
    const desc = sortDesc[0];
    items.sort((a, b) => {
      if (desc) {
        return `${b[sortKey]}`.localeCompare(`${a[sortKey]}`);
      }
      return `${a[sortKey]}`.localeCompare(`${b[sortKey]}`);
    });
    return items;
  }

  dataTableCustomSort(items, sortBy, sortDesc, sortFunction) {
    const sortKey = sortBy[0];
    const desc = sortDesc[0];
    items.sort((a, b) => {
      const result = sortFunction(a, b);
      if (result !== undefined) {
        return result;
      }
      if (desc) {
        return `${b[sortKey]}`.localeCompare(`${a[sortKey]}`);
      }
      return `${a[sortKey]}`.localeCompare(`${b[sortKey]}`);
    });
    return items;
  }

  /**
   * うみログデバイス一覧をセレクトボックス向けのデータに変換する
   * @param {うみログデバイス一覧} devices_list
   * @returns
   */
  deviceForSelectbox(devices_list) {
    const selectboxList = devices_list.map((device) => {
      return {
        text: device.item.name,
        value: device.item.device_id,
      };
    });
    return selectboxList;
  }
}

export default new ValueConverer();
